import React, { useState } from "react";
import AdminHOC from "../../../components/shared/HOC/AdminHOC";
import CustomInput from "../../../components/global/CustomInput/CustomInput";
import useSingleContentReport from "../../../hooks/CoursesHooks/useSingleContentReport";
import { useNavigate, useParams } from "react-router-dom";
import CommonTable from "../../../components/shared/table/Table";
import { singleContentColumns } from "../../../assets/constants/admin/singleContent";
import CustomButton from "../../../components/global/Button/CustomButton";
import { downloadSingleContentReport } from "../../../service/AdminService/courseService";
import { message } from "antd";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import searchIcomsvg from "../../../assets/icons/Search-Icon.svg";
import Back from "../../../assets/back-btn.svg";

const SingleContentReport = () => {
  const [isSearchHovered, setIsSearchHovered] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { courseId, contentId } = useParams();
  const navigate = useNavigate();

  const {
    data,
    loading,
    searchText,
    setSearchText,
    paginationConfig,
    handlePageChange,
    title,
  } = useSingleContentReport(courseId, contentId);

  const handleDownloadReport = async () => {
    setDownloadLoading(true);
    try {
      const params = {
        searchText,
      };

      const res = await downloadSingleContentReport(
        courseId,
        contentId,
        params,
      );

      if (!res.success) {
        console.error(res.message);
      } else {
        message.success("Report downloaded successfully");
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
    setDownloadLoading(false);
  };

  return (
    <div className="p-6 flex flex-col   border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] gap-6">
      <div className="flex justify-between">
        <p className="text-[#E74860] text-[1.75rem] font-normal">
          Report for {title}
        </p>
        <div
          className="flex gap-2 justify-center cursor-pointer items-center"
          onClick={() => navigate(-1)}
        >
          <img alt="back-btn" src={Back} />
          <span>Back</span>
        </div>
      </div>

      <div className="flex justify-between items-center ">
        <div
          onMouseEnter={() => setIsSearchHovered(true)}
          onMouseLeave={() => setIsSearchHovered(false)}
        >
          <CustomInput
            icon={
              isSearchHovered ? (
                <LottieIcon name="searchIcon" size={20} shouldPlay={true} />
              ) : (
                <img src={searchIcomsvg} alt="search" className="w-5 h-5" />
              )
            }
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-[200px]"
            placeholder="Search"
          />
        </div>
        <CustomButton disabled={downloadLoading} onClick={handleDownloadReport}>
          {" "}
          Export{" "}
        </CustomButton>
      </div>

      <CommonTable
        onChange={handlePageChange}
        loading={loading}
        showLoader={loading}
        pagination={paginationConfig}
        data={data}
        columns={singleContentColumns}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default AdminHOC(SingleContentReport);
